
import { defineComponent, computed } from "vue";
import BaseIcon from "../components/UI/Icons/BaseIcon.vue";

export default defineComponent({
  props: {
    type: {
      type: String,
      default: "404",
    },
  },
  components: {
    BaseIcon,
  },
  setup(props) {
    /** whether the error type is 404 */
    const isError404 = computed(() => {
      return props.type === "404";
    });
    const isError403 = computed(() => {
      return props.type === "403";
    });
    return {
      isError404,
      isError403,
    };
  },
});
